<div class="flex flex-column h-full">
  @if (loading()) {
    <div class="flex flex-column h-full justify-content-center align-items-center gap-2">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      <span> {{ "gate_faults.repair_modal.loading" | translate }} </span>
    </div>
  } @else {
    @if (form) {
      <div [formGroup]="form">
        <div class="flex flex-column gap-2 mb-3">
          <label for="notes" class="font-semibold w-full">{{ "gate_faults.repair_modal.notes" | translate }}</label>
          <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true" id="notes"></textarea>
        </div>
      </div>
    }
    <p-fileUpload
      #fileUpload
      [showUploadButton]="false"
      [showCancelButton]="false"
      styleClass="customFileUpload"
      [style]="{ 'flex-direction': 'row' }"
      class="w-full"
      [customUpload]="true"
      [auto]="false"
      invalidFileTypeMessage=""
      [chooseLabel]="translate.instant('gate_faults.repair_modal.add_image')"
      (onSelect)="onFileSelect($event); fileUpload.clear()"
      [accept]="ACCEPTED_FILE_TYPES.join(',')"
    >
      <ng-template #content let-uploadedFiles>
        @if (uploadedFiles.length > 0) {
          {{ uploadedFiles.length }}
          {{ "common.files_selected" | translate }}
        }
      </ng-template>
    </p-fileUpload>
    @if (files.length > 0) {
      <div class="list-compact-rows">
        <span class="listTitle">
          {{ "gate_faults.repair_modal.attachments" | translate }}
        </span>
        <div class="listItems">
          @for (file of files; let index = $index; track file) {
            <div class="listRow">
              <span>
                {{ file.name }}
              </span>
              <app-svg-icon
                (click)="onDeleteImage(index)"
                class="pointer"
                iconName="trash"
                iconColor="primary"
                iconSize="xs"
              ></app-svg-icon>
            </div>
          }
        </div>
      </div>
    }
    <div class="buttons">
      <app-button buttonText="gate_faults.repair_modal.cancel" (click)="cancel()"></app-button>
      <app-button buttonText="gate_faults.repair_modal.send_request" (click)="request()"></app-button>
    </div>
  }
</div>
